module.exports = __webpack_public_path__ + "img/faq_icon_active.2af19e01.svg";